import { Component, Inject } from '@angular/core';

@Component({
	selector: 'sn-app',
	template: `
                <div ng-view class="main-container sn-header-placeholder bottom-placeholder"></div>
                <upload-photo-modal></upload-photo-modal>
                
				<router-outlet class="main-container sn-header-placeholder bottom-placeholder"></router-outlet>
				
				<sn-iframe></sn-iframe>
				<subscription-announcement-banner></subscription-announcement-banner>
				<subscription-choose-plan></subscription-choose-plan>
				<two-fa-control></two-fa-control>
           `
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/app.component.ts